import debounce from 'lodash/debounce';
import '../header/js/main';
import '../generic_slider/js/main';
import '../gallery_modal/js/main';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

export default class Global {
    constructor() {
        this.initHeaders()
        this.noScrollClass = 'overflow-hidden'

        window.addEventListener("DOMContentLoaded", () => {
            const stickyHeader = document.querySelector('.js-sticky-header');
            if (typeof (stickyHeader) != 'undefined' && stickyHeader != null && window.location.pathname === "/") {
                this.initStickyHeader(stickyHeader)
            }

            document.addEventListener('click', (event) => {
                this.initSwitchText(event)
                this.initSidebars(event)
            })

            this.initTooltips()
            this.initShowMoreButtons()
            this.initHideableNavbar()
            this.initAOS()

            if (window.matchMedia('(min-width: 1200px)').matches) {
                this.initHoverCollection()
            }

            window.addEventListener('resize', () => {
                if (window.innerWidth >= 1200 && window.matchMedia('(min-width: 1200px)').matches) {
                    this.initHoverCollection()
                }
            })

            document.addEventListener('shopify:section:load', () => {
                this.initAOS()
            });
        })
    }

    initAOS() {
        AOS.init({
            once: true,
            duration: 600,
            disable: function () {
                return window.innerWidth < '991';
            }
        })
    }

    initHideableNavbar() {
        // remove active class from tab-link items in dropdown if clicked on tab-link
        document.querySelector('.nav-tabs')?.closest('.js-hideable-navbar')?.addEventListener('click', event => {
            const tabLink = event.target.closest('.tab-link')
            if (tabLink) {
                event.currentTarget.querySelectorAll('.js-hideable-dropdown-item a').forEach(link => {
                    link.classList.remove("active")
                })
            }
        })

        // on window resize
        this.resizeSensitiveFnc(() => {
            if (window.innerWidth >= SBBreakpoints.MD) {
                document.querySelectorAll('.js-hideable-navbar').forEach((navbar) => {
                    const navbarEl = navbar.closest('.js-hideable-navbar-wrapper') || navbar
                    const navbarItems = navbar.querySelectorAll('.js-hideable-item')
                    const dropdownItem = navbar.parentNode.querySelector('.js-hideable-dropdown-item')
                    const dropdownWrapper = dropdownItem.querySelector('.dropdown-menu')
                    const dropdownList = dropdownItem.querySelector('ul')

                    navbarEl.classList.add('overflow-hidden')
                    dropdownItem.classList.add("invisible")
                    dropdownList.innerHTML = ""
                    let navbarItemsWidth = 0

                    dropdownWrapper.previousElementSibling.addEventListener('shown.bs.dropdown', () => {
                        this.resizeSensitiveFnc(() => {
                            const posLeft = dropdownWrapper.getBoundingClientRect().left + dropdownWrapper.offsetWidth
                            document.documentElement.style.setProperty('--dropdown-position-top', `${dropdownWrapper.getBoundingClientRect().top}px`)
                            document.documentElement.style.setProperty('--dropdown-position-left', `${posLeft}px`)
                            document.documentElement.style.setProperty('--dropdown-height', `${dropdownWrapper.offsetHeight}px`)
                        })
                    })


                    // loop through all list items
                    navbarItems.forEach((item) => {
                        // show list item, so we can get its width and add it to total width of navbar items
                        item.classList.remove("hidden")
                        navbarItemsWidth += item.offsetWidth

                        // if total width of navbar items is more than container width
                        if (navbarItemsWidth + dropdownItem.offsetWidth > navbarEl.offsetWidth) {
                            const submenu = item.querySelector('.js-submenu')
                            // show dropdown and hide navbar item
                            dropdownItem.classList.remove("invisible")
                            item.classList.add("hidden")

                            // create list item for dropdown
                            const newEl = document.createElement('a')
                            const dropdownLinkClasses = ['dropdown-menu-link', 'whitespace-normal']
                            newEl.classList.add(...dropdownLinkClasses)
                            if (submenu) newEl.classList.add('has-submenu')
                            newEl.innerHTML = item.children[0].innerHTML
                            if (item.children[0].href) {
                                newEl.href = item.children[0].href
                            }

                            // if item is tab-link register click event to fake click on original tab
                            if (item.children[0].classList.contains("tab-link")) {
                                newEl.addEventListener('click', (e) => {
                                    item.children[0].click()
                                    newEl.closest('ul').querySelectorAll('a').forEach((child) => {
                                        child.classList.remove("active")
                                    })
                                    newEl.classList.add("active")
                                })
                            }

                            // create list item and add it to dropdown
                            const li = document.createElement('li')
                            li.classList.add('js-submenu-item')
                            li.appendChild(newEl)
                            dropdownList.appendChild(li)

                            // create submenu
                            if (submenu) {
                                const submenuItems = submenu.querySelectorAll('.js-submenu-item')

                                if (submenuItems) {
                                    const newSubmenu = document.createElement('ul')
                                    newSubmenu.classList.add('submenu', 'dropdown-menu', 'w-250', 'rounded-none')
                                    if (dropdownItem.classList.contains('js-dropdown-left')) {
                                        newSubmenu.classList.add('left')
                                    }

                                    submenuItems.forEach((link) => {
                                        const newItem = document.createElement('li')
                                        newItem.innerHTML = link.innerHTML
                                        newItem.children[0].className = ''
                                        newItem.children[0].classList.add(...dropdownLinkClasses)
                                        if (newItem.children[1]) {
                                            const links = newItem.children[1].querySelectorAll('a')
                                            if (links) {
                                                links.forEach((el) => {
                                                    el.className = ''
                                                    el.classList.add(...dropdownLinkClasses, 'pl-40')
                                                })
                                            }
                                        }
                                        newSubmenu.appendChild(newItem)
                                    })

                                    li.appendChild(newSubmenu)
                                }
                            }
                        }
                    })

                    // remove initial overflow-hidden class from navbar, class should be there to prevent glitches
                    navbarEl.classList.remove('overflow-hidden')
                })
            }
        })
    }

    initHoverCollection() {
        const links = document.querySelectorAll('.cl-link');
        const images = document.querySelectorAll('.cl-image');

        if (links.length) {
            this.itemsRemoveClass(links);
            links[0].classList.add('active');

            links.forEach((imageTarget) => {
                imageTarget.addEventListener('mouseover', () => {
                    this.itemsRemoveClass(links);

                    imageTarget.classList.add('active');

                    images.forEach((el) => {
                        el.classList.remove('active');
                    })


                    const dataTarget = imageTarget.dataset.imageTarget;
                    document.querySelector('[data-image-id="' + dataTarget + '"]').classList.add('active');
                })
            });
        }

    }

    itemsRemoveClass(items) {
        items.forEach((el) => {
            el.classList.remove('active');
        })
    }

    initStickyHeader(header) {
        let isLight = false
        if (document.querySelector('.main-header').classList.contains('light')) {
            isLight = true;
        }
        window.onscroll = function () {
            if (window.scrollY > 50) {
                header.classList.add('bg-light');
                if (isLight) {
                    header.classList.remove('light');
                    header.classList.add('dark');
                }
            } else {
                header.classList.remove('bg-light');
                if (isLight) {
                    header.classList.add('light');
                    header.classList.remove('dark');
                }
            }
        };
    }

    initShowMoreButtons() {
        const buttons = document.querySelectorAll('[data-text-target]');
        if (buttons.length) {
            buttons.forEach((el) => {
                const clampClass = 'line-clamp-3';
                const btnShowText = el.dataset.textShow;
                const btnHideText = el.dataset.textHide;
                const targetId = el.dataset.textTarget;
                const target = document.querySelector('[data-text-id="' + targetId + '"]');

                el.addEventListener('click', () => {
                    el.classList.toggle('active');

                    if (target.classList.contains(clampClass)) {
                        target.classList.remove(clampClass);
                        el.querySelector('span').innerHTML = btnHideText;
                    } else {
                        target.classList.add(clampClass);
                        el.querySelector('span').innerHTML = btnShowText;
                    }
                })
            })
        }
    }

    initCollapseHorizontal() {
        const btn = document.querySelectorAll('.js-collapse-horizontal');
        btn.forEach(el => {
            const attr = el.getAttribute('data-target');
            const collapseEl = document.getElementById(attr);
            el.addEventListener('click', (e) => {
                collapseEl.classList.toggle('collapsed');
                el.classList.contains("collapsed") ? el.classList.remove('collapsed') : el.classList.add('collapsed');
            });
        })
    }

    initSwitchText(event) {
        const el = event.target.closest('.js-switch-text')
        if (el) {
            const target = el.dataset.switchTarget ? el.querySelector(el.dataset.switchTarget) : el
            const state = el.dataset.switchState
            if (state === 'true') {
                el.dataset.switchState = 'false'
                target.innerText = el.dataset.switchFalse
                return
            }
            el.dataset.switchState = 'true'
            target.innerText = el.dataset.switchTrue
        }
    }

    initSidebars(event) {
        const el = event.target.closest('.js-sidebar-toggle')
        if (el?.dataset.sidebarTarget) {
            const sidebar = document.getElementById(el.dataset.sidebarTarget)
            if (this.sidebarActive) {
                this.closeSidebar(sidebar)
            } else {
                this.openSidebar(sidebar)
            }
            event.stopPropagation()
        }
    }

    openSidebar(sidebar) {
        this.bodyAddNoScroll()
        sidebar.classList.add('active')
        this.sidebarActive = true
    }

    closeSidebar(sidebar) {
        this.bodyRemoveNoScroll()
        sidebar.classList.remove('active')
        this.sidebarActive = false
    }

    bodyAddNoScroll() {
        document.body.setAttribute('style', `overflow:hidden;padding-right:${this.scrollbarWidth}px;`)
    }

    bodyRemoveNoScroll() {
        document.body.setAttribute('style', '')
    }

    initTooltips() {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        tooltipTriggerList.forEach(tooltipTriggerEl => {
            new bootstrap5.Tooltip(tooltipTriggerEl)
        })
    }

    initHeaders() {
        window.LS_COMPARATOR_KEY = "comparator_objects";
        window.SBBreakpoints = {
            LG: 1200,
            MD: 992,
            SM: 768,
        };
        window.SBFetchHeadersFnc = () => {
            return new Headers({
                "X-Requested-With": "XMLHttpRequest",
                //"X-CSRFToken": getCookie('csrftoken')
            })
        }

        window.SBFetchHeaders = window.SBFetchHeadersFnc();

        window.SBJSONFetchHeadersFnc = () => {
            return new Headers({
                "X-Requested-With": "XMLHttpRequest",
                // "X-CSRFToken": getCookie('csrftoken'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            });
        }

        window.SBJSONFetchHeaders = window.SBJSONFetchHeadersFnc();

        document.body.addEventListener('htmx:configRequest', (event) => {
            event.detail.headers['X-CSRFToken'] = getCookie('csrftoken');
        });
    }

    resizeSensitiveFnc(fnc, invokeImmediate = true) {
        if (invokeImmediate) {
            fnc();
        }
        window.addEventListener('resize', debounce(fnc, 100));
    }

    initScrollTo() {
        const hash = window.location.hash;
        if (hash && hash.length > 0) {
            const el = document.querySelector(hash)
            if (el) {
                setTimeout(() => {
                    window.scrollTo({top: el.offsetTop, behavior: "smooth"});
                }, 100)
            }
        }

        document.addEventListener('click', event => {
            const linkWithHash = event.target.closest('a[href*="#"]');
            if (linkWithHash) {
                const href = linkWithHash.getAttribute('href');
                if (href && href !== '#' && href !== '#0' &&
                    !linkWithHash.hasAttribute('data-toggle') &&
                    !linkWithHash.hasAttribute('data-bs-toggle')
                ) {
                    const el = document.querySelector(href)
                    if (el) {
                        window.scrollTo({top: el.offsetTop, behavior: "smooth"});
                    }
                }
            }
        });
    }

    initBoostrapModalHistoryApi() {
        const modals = document.querySelectorAll('div.modal')
        modals.forEach((modal) => {
            modal.addEventListener('show.bs.modal', (e) => {
                window.history.pushState('', document.title, `${window.location.pathname}#${e.target.id}`)
                window.onhashchange = () => {
                    if (window.location.hash !== e.target.id) {
                        window.bootstrap5.Modal.getInstance(e.target).hide()
                    }
                }
            })
            modal.addEventListener('hidden.bs.modal', () => {
                if (window.location.hash !== '') {
                    // if location hash is still 'something' modal was not hidden by browser navigation
                    // and we need to go back
                    window.history.replaceState('', document.title, window.location.pathname)
                }
            })
        })
    }

    showLoader(el) {
        el.classList.add('active');
    }

    hideLoader(el) {
        el.classList.remove('active');
    }
}